/** Build a POST /apartments body that satisfies ApartmentCreate validation. */
export function buildApartmentCreatePayload(form) {
  const num = (v) => {
    if (v === '' || v == null) return 0;
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };
  return {
    title: (form.title || '').trim(),
    address: (form.address || '').trim(),
    neighborhood: (form.neighborhood || '').trim(),
    rent: num(form.rent),
    size: num(form.size),
    rooms: Math.trunc(num(form.rooms)),
    furnished: Boolean(form.furnished),
    description: (form.description || '').trim(),
    property_manager_id: form.property_manager_id || null,
    source: form.source || null,
    external_url: form.external_url?.trim() || null,
  };
}

/** Map API apartment document to admin form state. */
export function apartmentToForm(apt) {
  if (!apt) {
    return {
      title: '',
      address: '',
      neighborhood: '',
      rent: '',
      size: '',
      rooms: '',
      furnished: false,
      description: '',
      property_manager_id: '',
      source: '',
      external_url: '',
    };
  }
  return {
    title: apt.title || '',
    address: apt.address || '',
    neighborhood: apt.neighborhood || '',
    rent: apt.rent != null && apt.rent !== '' ? String(apt.rent) : '',
    size: apt.size != null && apt.size !== '' ? String(apt.size) : '',
    rooms: apt.rooms != null && apt.rooms !== '' ? String(apt.rooms) : '',
    furnished: Boolean(apt.furnished),
    description: apt.description || '',
    property_manager_id: apt.property_manager_id || '',
    source: apt.source || '',
    external_url: apt.external_url || '',
  };
}

/** PATCH /apartments/{id} — same field shape as create. */
export function buildApartmentUpdatePayload(form) {
  return buildApartmentCreatePayload(form);
}
